import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';
import { Address, AddressData, GenericResponse } from 'src/app/entities/various';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { InvoicesService } from 'src/app/services/invoices/invoices.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-email-modal',
  templateUrl: './email-modal.component.html',
  styleUrls: ['./email-modal.component.css']
})
export class EmailModalComponent implements OnInit {

  @Input() invoiceId: string | undefined;
  @Input() userId : any | undefined;

  addresses : Address[] = [];
  selectedEmail : string ='';
  addressId : string | number ='';
  custom : boolean = false;
  params : HttpParams;
  filter : string = 'denominazione';
  search : boolean = false;

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal, private invoicesService: InvoicesService, 
    private toast : ToastService, private confService : ConfigurationService) { 
      this.params = new HttpParams();
    this.params =this.params.append('endRow', 0);
    this.params =this.params.append('lastKeyVal', '');
    this.params =this.params.append('page', 1);
    this.params =this.params.append('pageDirection', 'FORWARD');
    this.params =this.params.append('pageSize', 12);
    this.params =this.params.append('pagination', true);
    this.params =this.params.append('paginationMode', 'SKIP');
    this.params =this.params.append('rows', 0);
    this.params =this.params.append('searchFilter', '{}');
    this.params =this.params.append('sortDir', 'ASC');
    this.params =this.params.append('sortKey', 'denominazione');
    this.params =this.params.append('startRow', 0);
    this.params =this.params.append('totalPages', -1);
    this.params =this.params.append('totalRows', 0);
    }

  ngOnInit(): void {
  
   
  }

  close(){
    this.activeModal.close(false);
  }

  async searchAddress(val : string) {
    this.params = this.params.delete('searchFilter');
    this.params =this.params.append('searchFilter', '{"' + this.filter + '" : "' + val + '"}');
    this.addresses = await (await this.confService.getAddresses(this.userId!, this.params)).data.data;
    this.search = true;

  }

  selectAddress(val : string) {
    this.selectedEmail = val;
  }

  getEmail( json_data : string, id?: string | number) : string {
    let data: AddressData = JSON.parse(json_data);
    if(id) {
      this.addressId = id;
    }
    
    return data.DatiAnagrafici.Anagrafica.email;
  }

  async sendEmail () {
    if(this.selectedEmail!='' && this.selectedEmail) {
      let response = await this.invoicesService.sendFileViaEmail(this.userId, this.invoiceId!, this.selectedEmail);
      if(response.success) {
        this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.sendMail.success"), "success");
        this.activeModal.close(false);
      } else {
        this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.sendMail.error"), "error");
      }

    } else {
      this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.sendMail.warning"), "warning");
    }
  }


}
